import {useDebugStore} from '@sdox/ui'

import {EufePage} from './EufePage'
import {useRegisterInlineDisclaimers} from '../../hooks/useRegisterInlineDisclaimers'
import {ExternalLinkDisclaimerProvider} from '../../context/ExternalLinkDisclaimerContext'
import {useIsEditable} from '../DragAndDrop'

import type {EufePageFragment, ExternalLinkDisclaimerConfigFragment, XcDisclaimerInterfaceFragment} from '@sdox/api'

interface EufePagesProps {
  inlineDisclaimers: XcDisclaimerInterfaceFragment[]
  externalLinkDisclaimerConfig: ExternalLinkDisclaimerConfigFragment | null
  pages: EufePageFragment[]
}

export const EufePages = (props: EufePagesProps) => {
  const {externalLinkDisclaimerConfig, inlineDisclaimers, pages} = props
  const isDebug = useDebugStore().isDebugOnMode('data')
  const isEditable = useIsEditable()
  useRegisterInlineDisclaimers(inlineDisclaimers)

  const newPages = pages
    .filter(page => page.panels.reduce((prev, curr) => prev + curr.blocks.length, 0) > 0 || isDebug || isEditable)
    .map((page) => (
      <EufePage
        key={page.id}
        page={page}
      />
    ))

  return (
    <ExternalLinkDisclaimerProvider value={{config: externalLinkDisclaimerConfig}}>
      <div className={'grid gap-y-[--gap-page]'}>
        {newPages}
      </div>
    </ExternalLinkDisclaimerProvider>
  )
}
